@if (!isLoading) {
<div class="user-property-heading-row">
  <div>
    <h3>Properties</h3>
  </div>
</div>
<div class="user-property-list-table-container">
  <div class="mat-elevation-z8 hide-on-mobile">
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="displayName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Display Name </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading"><a (click)="viewProperty(property.id)">{{ property.displayName ?? '' }}</a></span>
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef>Featured Image</mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <img [src]="property.primaryImageUrl" style="height: 40px; border-radius: 12px; max-width: 40px;" alt="property main image"/>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Location </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.city ?? '' }}, {{ property.state }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="owner">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Host </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.ownerFirstName ?? '' }} {{ property.ownerLastName ?? '' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="saveCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Saves </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.saveCount }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isPublished">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Published</mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader skeleton-circle"></div>
          <ng-container *ngIf="!isLoading">
            <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
              {{ property.isPublished ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef> Created </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <ng-container *ngIf="isLoading">
            <div class="skeleton-loader skeleton-circle"></div>
          </ng-container>

          <ng-container *ngIf="!isLoading">
            {{ property.createdAt | date: 'MMMM dd, yyyy' }}
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expires">
        <mat-header-cell *matHeaderCellDef> Expires </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <ng-container *ngIf="isLoading">
            <div class="skeleton-loader skeleton-circle"></div>
          </ng-container>

          <ng-container *ngIf="!isLoading">
            {{ property.publishedExpiresAt | date: 'MMMM dd, yyyy' }}
          </ng-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let property of dataSource.connect() | async" class="mobile-property-card">
      <mat-card-header>
        <mat-card-title>
            
          <div mat-card-avatar>          
              <img [src]="property.primaryImageUrl" alt="property image" />
          </div>
          {{ property.displayName }}
        </mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <h3>
            
            <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
                  {{ property.isPublished ? 'check_circle' : 'cancel' }}
              </mat-icon>
            <div class="icon-container">
                <mat-icon>favorite</mat-icon>
                <span class="icon-number">{{ property.saveCount }}</span>
            </div>
        </h3>
        <p>{{ property.city }}, {{ property.state }}</p>
        <p>{{ property.ownerFirstName }} {{ property.ownerLastName }}</p>
        <p>Created: {{ property.createdAt | date: 'MMMM dd, yyyy' }}</p>
        <p>Expires: {{ property.publishedExpiresAt | date: 'MMMM dd, yyyy' }}</p>
    </mat-card-content>
    </mat-card>
  </div>

  <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" aria-label="Select page of properties">
  </mat-paginator>
</div>
} 